import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Three states: null = checking, true = ok, false = not authed
export default function ProtectedRoute({ children, adminOnly = true }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState(user ? true : null);

  useEffect(() => {
    if (loading) return;
    if (!user) { setState(false); navigate("/admin/login"); return; }
    if (adminOnly && !user.is_admin) { setState(false); navigate("/admin/denied"); return; }
    setState(true);
  }, [user, loading, adminOnly, navigate]);

  if (loading || state === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-emerald-950 text-emerald-100">
        <div className="w-10 h-10 border-2 border-brass border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (state !== true) return null;
  return children;
}
